import { getChatgptModelList } from "../api";

let modelConfigs = {};
let modelConfigsList = [];
// 辅助方法
export const hasFeature = (modelKey, feature) => {
  const model = modelConfigs[modelKey];
  return model?.features?.indexOf(feature) !== -1 || false;
};

// 获取模型显示名称
export const getModelDisplayName = (modelKey) => {
  const model = modelConfigs[modelKey];
  return model ? model.displayName : modelKey;
};

// 新增模型配置访问器
export const getModelConfig = (modelKey) => {
  const model = modelConfigs[modelKey];
  if (!model) {
    // console.warn(`未找到${modelKey}的模型配置，使用默认配置`);
    return modelConfigs["GPT4_MINI_API"];
  }
  return model;
};

export const getModelKeyName = (displayName) => {
  if (!modelConfigsList) {
    console.warn("模型配置为空");
    return displayName;
  }
  const model = modelConfigsList.find(
    (model) => model?.displayName === displayName
  );
  return model ? model.modelKey : displayName;
};

// 获取模型配置
export const initModelConfigList = async (isReturnList = false) => {
  try {
    const res = await getChatgptModelList();
    // 转换为前端所需格式
    const versionOptions = res.data.reduce((acc, model) => {
      // 构建模型标签，添加特殊标记
      let specialMarks = "";
      if (model.features?.includes("reasoning")) specialMarks += " 💡思考";
      if (model.features?.includes("deepsearch")) specialMarks += " 🌍联网搜索";
      if (model.features?.includes("mini")) specialMarks += " 🚀";
      if (model.features?.includes("cheap")) specialMarks += " 🔥";
      const quotaPerThousandTokens =
        model.promptQuota * 0.3 + model.completionQuota * 0.7;
      const formattedQuota =
        quotaPerThousandTokens < 1
          ? Math.round(quotaPerThousandTokens * 10) / 10 // 小于1时保留一位小数
          : Math.ceil(quotaPerThousandTokens); // 大于等于1时向上取整
      acc[model.modelKey] = {
        modelKey: model.modelKey,
        displayName: model.displayName,
        label: `${model.displayName}${specialMarks} [约${formattedQuota}配额/1k tokens]`,
        disabled: model.status !== "ACTIVE",
        features: model.features || [],
        baseQuota: model.baseQuota,
        continuousQuota: model.continuousQuota,
      };

      return acc;
    });
    // 转换为前端所需格式
    const versionOptionsList = res.data.map((model) => {
      // 构建模型标签，添加特殊标记
      let specialMarks = "";
      if (model.features?.includes("unstable")) specialMarks += "【不稳定】";
      if (model.features?.includes("new")) specialMarks += "✨";
      if (model.features?.includes("mini")) specialMarks += " 🚀";
      if (model.features?.includes("cheap")) specialMarks += " 🔥";
      if (model.features?.includes("reasoning")) specialMarks += " 💡";
      if (model.features?.includes("deepsearch")) specialMarks += " 🌍";
      if (model.features?.includes("upload-docs")) specialMarks += " 📄";
      if (model.features?.includes("upload-images")) specialMarks += " 🖼️";
      if (model.features?.includes("draw")) specialMarks += " 🎨";
      const quotaPerThousandTokens =
        model.promptQuota * 0.3 + model.completionQuota * 0.7;
      const formattedQuota =
        quotaPerThousandTokens < 1
          ? Math.round(quotaPerThousandTokens * 10) / 10 // 小于1时保留一位小数
          : Math.ceil(quotaPerThousandTokens); // 大于等于1时向上取整
      return {
        modelKey: model.modelKey,
        displayName: model.displayName,
        label: `${model.displayName}${specialMarks} [约${formattedQuota}配额/1k tokens]`,
        disabled: model.status !== "ACTIVE",
        features: model.features.split(",") || [],
      };
    });
    modelConfigs = versionOptions;
    modelConfigsList = versionOptionsList;
    // console.log(versionOptions);
    return isReturnList ? versionOptionsList : versionOptions;
  } catch (err) {
    console.error("获取模型配置失败:", err);
    throw err; // 向上抛出错误，让调用者处理
  }
};

// 获取默认模型
export const getDefaultModel = () => {
  return "DEEPSEEK_R1"; // 可以根据需要修改默认模型
};

// 获取模型配额
export const getContinuousDialogQuotUseBase = (
  modelKey,
  continuousDialogMaxNum,
  continuousCount
) => {
  if (!modelConfigs[modelKey]) {
    // console.warn(`未找到${modelKey}的模型配置，使用默认配置`);
    return "";
  }
  const model = modelConfigs[modelKey];
  var minContinuousCount = Math.min(
    continuousCount + 1,
    continuousDialogMaxNum
  );
  var baseQuota = model.baseQuota + minContinuousCount * model.continuousQuota;
  return baseQuota;
};

// 新增方法：获取所有模型的features集合（去重）
export const getAllFeatures = () => {
  // 如果模型列表为空，返回空数组
  if (!modelConfigsList || modelConfigsList.length === 0) {
    console.error("模型列表为空");
    return [];
  }

  // 收集所有模型的features
  const featuresSet = new Set();
  modelConfigsList.forEach((model) => {
    if (model.features && Array.isArray(model.features)) {
      model.features.forEach((feature) => featuresSet.add(feature));
    }
  });

  // console.log("收集到的features集合:", featuresSet);

  // 排除一些不需要显示的特殊feature (可选)
  const excludeFeatures = [
    "",
    "streaming",
    "continuous",
    "tools",
    "vision",
    "unstable",
    "roles",
  ]; // 根据需要添加不想显示的feature
  const filteredFeatures = Array.from(featuresSet).filter(
    (feature) => !excludeFeatures.includes(feature)
  );

  return filteredFeatures;
};
